import { useDNSConfig } from './DomaionDNSConfig';
import { Table } from '@/components/ats';
import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import './editorTable.css';
import { formatDNSRecords } from './dnsRecordsHelpers';
import { SHARED_EMAIL_API_SERVICES } from '../api';
import { useQuery } from '@tanstack/react-query';
import { useShowToast } from '@/hooks';
import { CenterSpinner } from '@/components/ats';
import { FORWARDING_LINK } from './constants';
import { MX_PROVIDERS } from './constants';

const PreRequisitesContent = ({ domainDetails, sharedEmailData }) => {
  //name-> host
  //value-> Required vlue
  //priority wont come from BE we want to set
  //status->is_active
  //Type-> sending= txt ,reciving=mx,tracking=CNAME
  const toast = useShowToast();

  const { data: dnsRecords, isLoading } = useQuery({
    queryKey: ['domain-dns', domainDetails?.id],
    queryFn: async () => {
      const data = await SHARED_EMAIL_API_SERVICES?.getDomainDNSRecords({
        id: domainDetails?.id,
      });
      if (!data || Object.keys(data).length === 0) {
        toast({
          title: 'Failed to get DNS records',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
      return data;
    },
  });

  if (isLoading) {
    return <CenterSpinner />;
  }

  //@ts-ignore
  const MXRecords =
    dnsRecords?.dns_records?.receiving?.map((record) => ({
      Host: record?.name || '',
      RequiredValue: record?.value || '',
      Type: record?.type || '',
      Priority: 10,
      Status: record?.is_active,
      Valid: record?.valid || 'unknown',
    })) || [];

  const formattedRecordsTable = formatDNSRecords(dnsRecords);

  const mxRecordsTable = [...MXRecords];

  // Get all unique keys from the records to create table headers
  const allKeys = new Set();
  formattedRecordsTable.forEach((record) => {
    Object.keys(record).forEach((key) => allKeys.add(key));
  });

  //eslint-disable-next-line react-hooks/rules-of-hooks
  const { getColumnConfig } = useDNSConfig({ formattedRecordsTable });

  const forwardingEmails =
    sharedEmailData?.shared_emails
      ?.filter((email) => email?.domain === domainDetails?.id)
      ?.map((email) => email?.email)
      ?.join(', ') || '';

  const primaryEmail = sharedEmailData?.shared_emails?.find(
    (email) => email?.is_primary
  );
  const forwardingEmail = 'forward@' + primaryEmail?.email?.split('@')[1];

  return (
    <>
      <Flex gap="12px" mb="12px" mt="20px" px="12px" alignItems="center">
        {dnsRecords.mx_provider !== MX_PROVIDERS?.NOT_FOUND &&
          dnsRecords.mx_provider !== MX_PROVIDERS?.MAILGUN && (
            <Flex
              bg={'primary-400'}
              borderRadius="full"
              width="20px"
              height="20px"
              minWidth="20px"
              minHeight="20px"
              alignItems="center"
              justifyContent="center"
              fontSize="xs"
              fontWeight="bold"
              overflow="hidden"
            >
              <KText color={'base-white'} fontSize="xs" fontWeight="bold">
                1
              </KText>
            </Flex>
          )}
        <KText color={'secondary-900'} size={'md-bold'}>
          Add the following entries to your DNS records{' '}
        </KText>
      </Flex>
      <Table
        columns={Object.values(getColumnConfig)}
        data={formattedRecordsTable}
        tableContainerStyles={{
          mt: '12px',
          height: 'fit-content',
          className: 'share-email-editor-style table',
          px: '4px',
          _hover: {
            cursor: 'default',
            backgroundColor: '#fffff',
          },
        }}
        layoutStyles={{
          display: 'flex',
          alignItems: 'start',
          _hover: {
            cursor: 'default',
            backgroundColor: '#fffff',
          },
        }}
        tableLayoutStyles={{
          display: 'flex',
          alignItems: 'start !important',
          _hover: {
            cursor: 'default',
            backgroundColor: '#fffff',
          },
        }}
      />
      {dnsRecords.mx_provider !== MX_PROVIDERS?.NOT_FOUND &&
        domainDetails?.mx_provider !== MX_PROVIDERS?.MAILGUN && (
          <>
            <KText
              size={'sm-medium'}
              backgroundColor={'secondary-25'}
              px="24px"
              py="12px"
              mt="32px"
              mx="26px"
              borderRadius="6px"
              position={'relative'}
              bottom="0.75rem"
            >
              <b>Note:</b> You can add Kula's MX records to your DNS or create a
              forwarding rule with your current email provider to receive
              replies from candidates{' '}
            </KText>
            <Table
              columns={Object.values(getColumnConfig)}
              data={mxRecordsTable}
              tableContainerStyles={{
                mt: '12px',
                height: 'fit-content',
                className: 'share-email-editor-style table',
                px: '4px',
              }}
              layoutStyles={{
                display: 'flex',
                alignItems: 'start',
              }}
              tableLayoutStyles={{
                display: 'flex',
                alignItems: 'start !important',
                height: 'fit-content',
              }}
            />
            <>
              {(domainDetails?.mx_provider === MX_PROVIDERS?.GOOGLE ||
                domainDetails?.mx_provider === MX_PROVIDERS?.MICROSOFT) && (
                <>
                  <Flex
                    gap="12px"
                    mb="12px"
                    px="12px"
                    alignItems="center"
                    mt="24px"
                  >
                    <Flex
                      bg={'primary-400'}
                      borderRadius="full"
                      width="20px"
                      height="20px"
                      minWidth="20px"
                      minHeight="20px"
                      alignItems="center"
                      justifyContent="center"
                      fontSize="xs"
                      fontWeight="bold"
                      overflow="hidden"
                    >
                      <KText
                        color={'base-white'}
                        fontSize="xs"
                        fontWeight="bold"
                      >
                        2
                      </KText>
                    </Flex>
                    <KText color={'secondary-900'} size={'md-bold'}>
                      Set up a forwarding rule{' '}
                    </KText>
                  </Flex>
                  <KText mt="16px" mb="8px" px="24px">
                    Follow the instructions in the link below to set up the
                    forwarding rule from{' '}
                    <span
                      style={{
                        color: '#503BF0',
                        marginRight: '2px',
                      }}
                    >
                      {forwardingEmails}
                    </span>{' '}
                    to
                    <span
                      style={{
                        color: '#503BF0',
                        marginRight: '2px',
                        marginLeft: '2px',
                      }}
                    >
                      {forwardingEmail}
                    </span>
                    .
                    {domainDetails?.mx_provider === MX_PROVIDERS?.GOOGLE && (
                      <>
                        Ensure 'Messages affected' is set to
                        <span
                          style={{
                            color: '#413B74',
                            marginLeft: '2px',
                          }}
                        >
                          'All messages'{' '}
                        </span>
                      </>
                    )}
                  </KText>
                  {(domainDetails?.mx_provider === MX_PROVIDERS?.GOOGLE ||
                    domainDetails?.mx_provider === MX_PROVIDERS?.MICROSOFT) && (
                    <KText
                      color="primary-600"
                      px="24px"
                      onClick={() => {
                        const link =
                          domainDetails?.mx_provider === MX_PROVIDERS?.GOOGLE
                            ? FORWARDING_LINK.google
                            : FORWARDING_LINK.microsoft;
                        window.open(link, '_blank');
                      }}
                      cursor="pointer"
                    >
                      {' '}
                      {domainDetails?.mx_provider === MX_PROVIDERS?.GOOGLE
                        ? FORWARDING_LINK.google
                        : FORWARDING_LINK.microsoft}
                    </KText>
                  )}
                </>
              )}
              {domainDetails?.mx_provider === MX_PROVIDERS?.NOT_FOUND && (
                <>
                  <Flex gap="12px" mb="12px" px="12px" alignItems="center">
                    <Flex
                      bg={'primary-400'}
                      borderRadius="full"
                      width="20px"
                      height="20px"
                      minWidth="20px"
                      minHeight="20px"
                      alignItems="center"
                      justifyContent="center"
                      fontSize="xs"
                      fontWeight="bold"
                      overflow="hidden"
                    >
                      <KText
                        color={'base-white'}
                        fontSize="xs"
                        fontWeight="bold"
                      >
                        2
                      </KText>
                    </Flex>
                    <KText color={'secondary-900'} size={'md-bold'}>
                      Set up a forwarding rule{' '}
                    </KText>
                  </Flex>
                  <KText my="16px" px="24px">
                    Set up the forwarding rule from{' '}
                    <span
                      style={{
                        color: '#503BF0',
                        marginRight: '2px',
                        marginLeft: '2px',
                      }}
                    >
                      {forwardingEmails}
                    </span>{' '}
                    to
                    <span
                      style={{
                        color: '#503BF0',
                        marginRight: '2px',
                        marginLeft: '2px',
                      }}
                    >
                      {forwardingEmail}
                    </span>{' '}
                    In your email provider’s admin settings and ensure all
                    emails are forwarded to{' '}
                    <span
                      style={{
                        color: '#503BF0',
                        marginRight: '2px',
                        marginLeft: '2px',
                      }}
                    >
                      {forwardingEmail}
                    </span>
                    .
                  </KText>
                </>
              )}
            </>
          </>
        )}
    </>
  );
};

export default PreRequisitesContent;
